"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Insights = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _InfoBar = require("../InfoBar");

var _ToolBar = require("../ToolBar");

var _Page = require("../../Layout/Page");

var _Loading = _interopRequireDefault(require("../../Loading"));

var _ExpandableGroup = require("../ExpandableGroup");

var _utils = require("../utils");

var _hooks = require("../utils/hooks");

var _options = require("../utils/options");

var _analysis = require("../../../context/analysis");

var _useActions = require("../../../context/insights/useActions");

var _insights = require("../../../context/insights");

var _storage = require("../../../utils/storage");

var _constants = require("../utils/constants");

var _LoadingOverlay = require("../../ActionModals/components/LoadingOverlay");

const onTimeRangeChange = (updateTimeRange, history) => days => {
  (0, _utils.updateQueryString)(`${days}`, history, 'daysRange');
  updateTimeRange(days);
};

const Insights = /*#__PURE__*/React.memo(({
  history,
  timeRange,
  showSnoozed,
  updateHistory,
  updateTimeRange
}) => {
  const {
    setViewMode
  } = (0, _analysis.useActions)();
  React.useEffect(() => {
    setViewMode('insights');
  }, []);
  const [state, dispatch] = (0, _insights.useInsights)();
  const actions = (0, _useActions.useActions)();
  const {
    setQuery
  } = (0, _hooks.useQueryState)(history, updateHistory);
  const counts = (0, _hooks.useCounts)(state.groupBy, state.composedAndGroupedOccurrences, state.composedAndGroupedInsights, showSnoozed);
  const onSearch = React.useCallback(value => {
    dispatch({
      type: 'SET_COMPOSED_FILTERED_OCCURRENCES',
      composedFilteredOccurrences: value.filtered,
      search: value.query
    });
    setQuery(value.query);
  }, [state.isProcessed, state.rawData]);
  const onExpandAll = React.useCallback(() => {
    (0, _storage.clearStorage)({
      key: _constants.EXPANDING_KEY.insights
    });
    actions.toggleExpandAll();
  }, [actions.toggleExpandAll]);
  const timeRangeOption = React.useMemo(() => {
    return _options.TIME_RANGE_OPTIONS.insights.find(o => o.value === timeRange);
  }, [timeRange]);
  if (state.isLoading && !state.isLoaded) return /*#__PURE__*/React.createElement(_Loading.default, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, state.isProcessed && /*#__PURE__*/React.createElement(_Page.PageHeader, null, /*#__PURE__*/React.createElement(_blocks.DisplayMedium, null, /*#__PURE__*/React.createElement(_InfoBar.InfoBar, {
    insightsCount: counts.insightsCount,
    siteCount: counts.siteCount,
    equipCount: counts.equipCount,
    timeRange: timeRangeOption != null ? timeRangeOption.label(_core.i18n) : ''
  }))), state.isComposed && /*#__PURE__*/React.createElement(_ToolBar.ToolBar, {
    searchData: state.composedOccurrences,
    snoozedCount: counts.snoozedCount,
    currentGroup: state.groupBy,
    currentSort: state.sortBy,
    timeRange: timeRange,
    expandAll: state.expandAll,
    onExpand: onExpandAll,
    onSearch: onSearch,
    searchSessionKey: "insightsSearch",
    initialSearch: state.search,
    onTimeRangeChange: onTimeRangeChange(updateTimeRange, history),
    onGroupChange: actions.setGroupBy,
    onSortChange: actions.setSortBy,
    exportRawData: counts.insightsCount > 0 ? state.composedAndGroupedInsights : undefined
  }), /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingContainer, null, state.isLoading && /*#__PURE__*/React.createElement(_LoadingOverlay.LoadingOverlay, {
    opacity: 0.6
  }), state.composedAndGroupedInsights.length > 0 && state.composedFilteredOccurrences.length > 0 && /*#__PURE__*/React.createElement(_ExpandableGroup.ExpandableGroup, {
    finalGrouped: {
      composed: state.composedAndGroupedInsights,
      group: state.groupBy
    },
    showSnoozed: showSnoozed,
    expandAll: state.expandAll,
    filtered: state.composedFilteredOccurrences
  })));
}, (p, c) => p.timeRange !== c.timeRange && p.showSnoozed !== c.showSnoozed);
exports.Insights = Insights;